module.exports = __webpack_public_path__ + "static/media/axegprokeyboard-1.3376a7d5.jpg";